import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { getInitialLocale, SUPPORTED_LOCALES } from "./utils/locale";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fieldsChangedColor: 'amber',
    sectionTitle: "",
    status: "",
    hasCodeRunBefore: null,
    token: localStorage.getItem("token") || "",
    user: JSON.parse(localStorage.getItem("user")) || "",
    snackbar: {
      visible: false,
      color: "success",
      text: null,
      timeout: 8000,
      multiline: false,
    },
    language: getInitialLocale("es"),
    endpoint: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_PROD_BACKEND_ENDPOINT : process.env.VUE_APP_DEB_BACKEND_ENDPOINT
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, data) {
      state.status = "success";
      state.token = data.token;
      state.user = data.user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = "";
    },
    alert(state, payload) {
      state.snackbar.text = payload.text;

      // Si es mas de 50 caracteres definirlo como multilinea
      if (payload.multiline) {
        state.snackbar.multiline = payload.multiline;
      }

      // Tipo error/success y duración del mensaje
      if (payload.color) {
        state.snackbar.color = payload.color;
        if (payload.color == "error") state.snackbar.timeout = 12000;
        else state.snackbar.timeout = 8000;
      }

      // Mostrar
      state.snackbar.visible = true;
    },
    closeAlert(state) {
      state.snackbar.visible = false;
      state.snackbar.multiline = false;
      state.snackbar.text = null;
    },
    setLocale(state, lang) {
      if (SUPPORTED_LOCALES.includes(lang)) {
        localStorage.setItem("language", lang);
        state.language = lang;
      }
    },
    setHasCodeRunBefore(state){
      localStorage.setItem("hasCodeRunBefore", true);
      state.hasCodeRunBefore = true;
    }
  },
  actions: {
    setCheckToken({ commit }){
      commit("setHasCodeRunBefore")
    },
    setLanguage({ commit }, language) {
      if (typeof language === "string") {
        commit("setLocale", language);
      }
    },
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: this.state.endpoint + "/login/",
          data: user,
          method: "POST"
        })
          .then(resp => {
            const token = "token " + resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", token);
            localStorage.setItem("user", JSON.stringify(user));
            axios.defaults.headers.common["Authorization"] = token;
            commit("auth_success", { token, user });
            resolve(resp);
          })
          .catch(err => {
            commit("auth_error");
            document.cookie ='sessionid=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axios({ url: this.state.endpoint + "/logout/", method: "POST" })
          .then(resp => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            delete axios.defaults.headers.common["Authorization"];
            document.cookie ='sessionid=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            commit("logout");
            resolve();
          })
          .catch(err => {
            commit("auth_error");
            document.cookie ='sessionid=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            reject(err);
          });
      });
    },

    forceLogout({ commit }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        delete axios.defaults.headers.common["Authorization"];
        document.cookie ='sessionid=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        commit("logout");
        resolve();
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    user: state => state.user,
    isAdmin: state => state.user.groups.some(group => ['apoyo'].includes(group.name)),
    isDirector: state =>  state.user.groups.some(group => ['direccion'].includes(group.name)),
    isInternal: state => state.user.groups.some(group => ['interno'].includes(group.name)),
    getFieldsChangedColor: state => state.fieldsChangedColor
  }

});
